<section class="flowpay-video-wrapper">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <!-- desktop heading -->
        <div
          class="box__heading color-gray box__heading--desktop"
          [innerHTML]="'FLOWPAY.VIDEO_ONLINE.HEADING' | translate"
        >
        </div>

        <div class="btn-wrapper">
          <a
            class="btn-try-free"
            href="https://form.flowaccount.com/request-payment"
            aria-label="Request payment"
            rel="nofollow noopener"
            target="_blank"
            aria-label="link register try FlowAccount for free"
          >
            {{ 'FLOWPAY.FLOWPAY_INTRO.BTN_REGISTER_FOR_FREE' | translate }}
          </a>
        </div>
      </div>
      <div class="box__right">
        <div class="box__item" (click)="linkVideo('TFqPbdFvSlA')" data-toggle="modal" data-target="#functionVideo">
          <div class="box__item-cover">
            <div class="box__item-cover--bg"></div>
            <picture>
              <source
                srcset="https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_video_v5.webp"
                type="image/webp"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/functions/flowpay/FlowPay_video_v5.jpg"
                class="box__image"
                alt="สร้างระบบการชำระเงินออนไลน์ให้กับร้านค้าได้ง่ายๆ ด้วย FlowAccount"
                title="สร้างระบบการชำระเงินออนไลน์ให้กับร้านค้าได้ง่ายๆ ด้วย FlowAccount"
                loading="lazy"
              />
            </picture>

            <div class="box__item-cover--icon">
              <picture>
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/webp"
                />
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/jpeg"
                />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  class="icon-play"
                  alt="การแชร์ลิงก์เอกสารเพื่อบริการรับชำระเงินออนไลน์"
                  title="การแชร์ลิงก์เอกสารเพื่อบริการรับชำระเงินออนไลน์"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
